import React, { FC } from "react";
import { Control } from "react-hook-form";

import FilterRangeBase, { FilterRangeBaseProps } from "@/components/ui/Form/Filters/components/Range/RangeBase";
import FilterRangeControlled from "@/components/ui/Form/Filters/components/Range/RangeControlled";

export interface FilterRangeProps extends FilterRangeBaseProps {
  control?: Control<any>;
}
const FilterRange: FC<FilterRangeProps> = (args) => {
  return <>{args?.control ? <FilterRangeControlled control={args.control} {...args} /> : <FilterRangeBase {...args} />}</>;
};
export default FilterRange;
